import * as Yup from 'yup'

import { formatNumber } from '../../../../../helpers/numbers'

import { BID_PRICE } from '../../../../Tiktok/LineItemForms/LineItemTikTokCreate/LineItemTikTokCreateForm/fields'
import { BUDGET } from '../../../../Tiktok/LineItemForms/LineItemTikTokEdit/fields'

export const getValidationSchema = ({ remainingBudget, lineItem, showBidPrice }) => {
  const { [BUDGET]: budget } = lineItem

  // In edit form we need to sum: remainingBudget + budget, to represent the max value user can enter
  const maxBudget = remainingBudget + budget
  const formattedMaxBudget = formatNumber(maxBudget, { max: 2 })

  const budgetSchema = Yup.number()
    .typeError('Budget must be a number')
    .min(1, 'Budget must be greater than 0')
    .required('Budget is required')

  return Yup.object().shape({
    [BUDGET]: remainingBudget
      ? budgetSchema.max(maxBudget, `Must be less than or equal to ${formattedMaxBudget}`)
      : budgetSchema,
    ...(showBidPrice && {
      [BID_PRICE]: Yup.number().required('Please enter a bid price')
    })
  })
}
